import React from 'react';
import cn from 'classnames';
import { useMediaQuery } from 'usehooks-ts';
import './CarModelDetailsMarks.scss';

const getClassName = (el) => {
  return cn('mark', el.open && 'mark_active');
};

// 获取点位样式，从 Sitecore 数据读取位置
const getMarkStyle = (mark, isMobile = false, isTablet = false, hasAnyActive = false) => {
  const fields = mark.fields;
  const isActive = mark.open;

  // 根据设备类型和激活状态选择对应的位置数据
  let left, top;

  if (isMobile) {
    if (hasAnyActive) {
      // 移动端：如果有任何点位被选中，所有点位都使用激活位置
      left = fields.mobileActiveLeft?.value || fields.mobileLeft?.value || 0;
      top = fields.mobileActiveTop?.value || fields.mobileTop?.value || 0;
    } else {
      // 移动端：没有点位被选中时，使用正常位置
      left = fields.mobileLeft?.value || 0;
      top = fields.mobileTop?.value || 0;
    }
  } else if (isTablet) {
    if (hasAnyActive) {
      // 平板端：如果有任何点位被选中，所有点位都使用激活位置
      left = fields.tabletActiveLeft?.value || fields.tabletLeft?.value || 0;
      top = fields.tabletActiveTop?.value || fields.tabletTop?.value || 0;
    } else {
      // 平板端：没有点位被选中时，使用正常位置
      left = fields.tabletLeft?.value || 0;
      top = fields.tabletTop?.value || 0;
    }
  } else {
    if (hasAnyActive) {
      // PC端：如果有任何点位被选中，所有点位都使用激活位置
      left = fields.desktopActiveLeft?.value || fields.desktopLeft?.value || 0;
      top = fields.desktopActiveTop?.value || fields.desktopTop?.value || 0;
    } else {
      // PC端：没有点位被选中时，使用正常位置
      left = fields.desktopLeft?.value || 0;
      top = fields.desktopTop?.value || 0;
    }
  }

  return {
    position: 'absolute',
    left: `${left}%`,
    top: `${top}%`,
    // width: '48px',
    // height: '48px',
    zIndex: 4,
  };
};

export default function Marks({ tab, onClickMark }) {
  // 使用 useMediaQuery 检测屏幕尺寸
  const isMobile = useMediaQuery('(max-width: 480px)');
  const isTablet = useMediaQuery('(max-width: 834px) and (min-width: 481px)');

  // 检查是否有任何点位被选中
  const hasAnyActive = tab?.marks?.some((mark) => mark.open) || false;

  return tab.marks.map((el) => {
    return (
      <button
        key={el.fields.index.value}
        className={getClassName(el)}
        style={getMarkStyle(el, isMobile, isTablet, hasAnyActive)}
        onClick={() => onClickMark(el.fields.index.value)}
        data-hover-text={el.fields?.hoverText?.value}
      />
    );
  });
}
